@if (credentialKey()) {
  <div class="qr-code">
    <qrcode [qrdata]="qrcode()" [errorCorrectionLevel]="'M'"></qrcode>
  </div>
} @else {
  <p class="text-gray-500 font-medium">
    {{ 'platform.desktop.issue_with_credential_key' | translate }}
  </p>
}

